import { captureException } from '@sentry/angular';

export function handleError(error, force = false, production = true) {
  if (!(error && (error.status === 0 || error.status === 404)) || (force && error.status !== 0)) {
    captureException(error);
  }

  if (!production) {
    console.error(error);
  }
}
